import axios from 'axios'
import {BUSCAR_RESUMO_FINANCEIRO, BUSCAR_RESUMO_FINANCEIRO_ITINERARIO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import moment from 'moment';

export function buscarResumoFinanceiro(idEmpresa, dataInicio, dataFim, tipoConsulta, ehEncomenda) {
    let url = `${URL}/resumo-financeiro/empresa/${idEmpresa}?tipo=${tipoConsulta}&dataInicio=${moment(dataInicio)
        .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
        .format('YYYY-MM-DD')}&ehEncomenda=${ehEncomenda}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_RESUMO_FINANCEIRO,
            payload: response.data

        })
    );
}

export function buscarResumoFinanceiroItinerario(idEmpresa, dataInicio, dataFim, tipoConsulta, ehEncomenda) {
    let url = `${URL}/resumo-financeiro/empresa/${idEmpresa}/itinerario?tipo=${tipoConsulta}&dataInicio=${moment(dataInicio)
        .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
        .format('YYYY-MM-DD')}&ehEncomenda=${ehEncomenda}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_RESUMO_FINANCEIRO_ITINERARIO,
            payload: response.data

        })
    );
}
